import React from 'react'

export function ServerError() {
    return (
        <div className="PageError">
            <h1 className="mt-5">500. Server error</h1>
        </div>
    )
}



// WEBPACK FOOTER //
// src/pages/Errors/ServerError/ServerError.js